import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isClinicAuthenticated } from '../../Utils/clinicAuth';
import { sessionStore } from '../../Store/sessionStore';
import SessionExpiredModal from '../../Dashboard/SessionExpiry';

const AuthProtectedDashboardRoute = ({ isLoggedInPage }) => {
  const isLoggedIn = isClinicAuthenticated();
  const [, setObservedAuth] = useState(isLoggedIn);
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => sessionStore.subscribe(() => setSessionExpired(true)), []);

  useEffect(() => {
    const syncAuth = () => setObservedAuth(isClinicAuthenticated());

    window.addEventListener('pageshow', syncAuth);
    window.addEventListener('storage', syncAuth);
    window.addEventListener('focus', syncAuth);

    return () => {
      window.removeEventListener('pageshow', syncAuth);
      window.removeEventListener('storage', syncAuth);
      window.removeEventListener('focus', syncAuth);
    };
  }, []);

  if (isLoggedInPage) {
    if (!isLoggedIn) return <Navigate to="/login" replace />;
    return (
      <>
        <SessionExpiredModal visible={sessionExpired} />
        <Outlet />
      </>
    );
  }

  return isLoggedIn ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default AuthProtectedDashboardRoute;
